var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.7437L12 2.74365L17.5 11.7437H6.5ZM17.5 22.7437C16.25 22.7437 15.1877 22.3063 14.313 21.4317C13.4383 20.557 13.0007 19.4943 13 18.2437C12.9993 16.993 13.437 15.9307 14.313 15.0567C15.189 14.1827 16.2513 13.745 17.5 13.7437C18.7487 13.7423 19.8113 14.18 20.688 15.0567C21.5647 15.9333 22.002 16.9957 22 18.2437C21.998 19.4917 21.5607 20.5543 20.688 21.4317C19.8153 22.309 18.7527 22.7463 17.5 22.7437ZM3 22.2437V14.2437H11V22.2437H3ZM17.5 20.7437C18.2 20.7437 18.7917 20.502 19.275 20.0187C19.7583 19.5353 20 18.9437 20 18.2437C20 17.5437 19.7583 16.952 19.275 16.4687C18.7917 15.9853 18.2 15.7437 17.5 15.7437C16.8 15.7437 16.2083 15.9853 15.725 16.4687C15.2417 16.952 15 17.5437 15 18.2437C15 18.9437 15.2417 19.5353 15.725 20.0187C16.2083 20.502 16.8 20.7437 17.5 20.7437ZM5 20.2437H9V16.2437H5V20.2437ZM10.05 9.74365H13.95L12 6.59365L10.05 9.74365Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.4e87ef38d4c285474209f79afa899c7a.svg";
export { ForwardRef as ReactComponent };